<template>
  <div class="page page-help content">
    <h1 class="page__title">{{ t('help.menuTitle') }}</h1>
    <div v-if="content" v-html="content"></div>
  </div>
</template>

<script setup>
  import { ref, onMounted } from 'vue'
  import Axios from 'axios'
  import { useStrings } from '@/composables/useStrings.ts'
  import { useAuthStore } from '@/stores/useAuthStore'
  import { useLogError } from '@/composables/useLogError'
  import { useHttpClient } from '@/composables/useHttpClient'

  const { t } = useStrings()
  const { logError } = useLogError()
  const { strapiApi } = useHttpClient()
  const content = ref(null)

  onMounted(async () => {
    try {
      const response = await strapiApi.get('/api/app-help')
      content.value = response.data.data?.Hilfe ?? null
    } catch (err) {
      logError('Failed to load help content: ' + err)
    }
  })
</script>

<style lang="scss">
  .page-help {
    max-width: $content-page-width;
  }
</style>
